import moment from "moment";

/**
 * Format date string for table cells
 * @param {string} cell iso format date string
 */
export function dateFormatter(cell) {
  return cell ? moment(cell).format("MMM D, YYYY") : "";
}
